"use strict";

/**
 * @generated SignedSource<<32c46ed1f94a18f4b62e6dd760c26e11>>
 * @relayHash c8b6ccf96a6d81e0c2e90926a3b5b07f
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3595d4b94f90e17c6901e62d86ad7f7f31c0bca1d22c0a2fdfb6520da7af5bd1

const node = function () {
  var v0 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dbId",
      "storageKey": null
    },
    v1 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    };
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "useViewerAccountQuery",
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [v0 /*: any*/, v1 /*: any*/],
        "storageKey": null
      }],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "useViewerAccountQuery",
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [v0 /*: any*/, v1 /*: any*/, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }]
    },
    "params": {
      "id": "3595d4b94f90e17c6901e62d86ad7f7f31c0bca1d22c0a2fdfb6520da7af5bd1",
      "metadata": {},
      "name": "useViewerAccountQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "7dc74885d1e59aee84f60e3de0d62cf5";
export default node;